import {
  ProductTile,
  ProductTileProps,
} from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile";
import { ProductTileType } from "@faire/deprecated-retailer-visitor-shared/features/MarketplaceItems/ProductTile/types";
import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { useQuery_escape_hatch as useBulkFetchProductsQuery } from "@faire/web-api--source/endpoints/www/api/v3/layout/bulk-product-tiles/post-hooks";
import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { ProductTileScreen } from "@faire/web-api--source/indigofair/data/ProductTileScreen";
import { ProductTileScreenContainer } from "@faire/web-api--source/indigofair/data/ProductTileScreenContainer";
import { Grid, IGridProps } from "@faire/web/slate/Layout";
import React from "react";

import { deduplicateProductsOrBrands } from "./utils";

// TODO: Event Tracking
export interface IProductInput
  extends Pick<ProductTileProps, "type" | "loggingContext"> {
  token: string;
}

interface IProps extends Omit<IGridProps, "children" | "columnTemplate"> {
  products: IProductInput[];
}

export const BuilderRetailerProductTilesSection: React.FC<IProps> = ({
  products,
  ...gridProps
}) => {
  const isLoggedIn = useIsLoggedInRetailer();
  const context =
    `${ProductTileContainer.MERCHANDISED_COLLECTIONS_GRID}|${""}` as const;

  const deduplicatedProducts = deduplicateProductsOrBrands(products);

  const { data, isPending } = useBulkFetchProductsQuery({
    product_tokens: deduplicatedProducts.map((product) => product.token),
  });

  if (isPending || !data) {
    return null;
  }

  const { product_tiles, brands_by_token, request_id } = data;

  return (
    <Grid {...gridProps} className="w-full">
      {product_tiles?.map((productTile, index) => (
        <ProductTile
          key={productTile.product?.token}
          product={productTile}
          brand={
            brands_by_token[productTile.product?.brand_token ?? ""] ?? undefined
          }
          isLoggedIn={isLoggedIn}
          loggingContext={{
            // TODO: Placeholder
            impressionProviderProps: {
              context: context,
              productTileContainer:
                ProductTileContainer.MERCHANDISED_COLLECTIONS_GRID,
              containerName: "builder-io-product-tiles-section",
              requestId: request_id,
              screenContext: ProductTileScreen.MERCHANDISED_COLLECTIONS,
              containerContext:
                ProductTileScreenContainer.MERCHANDISED_COLLECTIONS_PRODUCTS,
              contextToken: "",
              trackedLinkContainerName: "",
            },
          }}
          type={
            deduplicatedProducts[index]?.type ??
            ProductTileType.TILE_WITHOUT_BRAND
          }
        />
      ))}
    </Grid>
  );
};
